import React from 'react';

function Avatar({ size, strokeWidth, stroke, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path
        d="M13.5 22.9502V24.7502C13.5 25.8752 12.9375 27.6752 7.3125 28.6877C5.76556 28.947 4.33806 29.6825 3.22894 30.7916C2.11982 31.9008 1.38434 33.3283 1.125 34.8752H34.875C34.4344 33.3193 33.5697 31.9167 32.3777 30.824C31.1857 29.7313 29.7132 28.9916 28.125 28.6877C22.5 27.6189 22.5 25.8752 22.5 24.7502V22.9502"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M25.875 14.4C25.875 20.025 22.3312 24.75 18 24.75C13.6688 24.75 10.125 20.25 10.125 14.625V9.225C10.125 3.375 14.2875 1.125 18 1.125C21.7125 1.125 25.875 3.15 25.875 9V14.4Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  );
}

export default Avatar;
